// Daily bus departure + hotel pickup times (Kenya/Tanzania UTC+3).
// Keep in sync with supabase/functions/_shared/bus/pickupTimes.ts

/** Hotel collection times keyed by origin city → departure HH:MM */
export const HOTEL_PICKUP_BY_CITY = {
  Nairobi: { '08:00': '07:00', '14:00': '13:00' },
  Arusha: { '08:00': '07:30', '14:00': '13:30' },
  Moshi: { '06:00': '05:30' },
};

/** Main staging / reporting points per city (catalog hotel name) */
export const MAIN_STATION_BY_CITY = {
  Nairobi: 'Parkside Hotel',
  Arusha: 'Kabila Junction',
  Moshi: 'YMCA',
};

/** Main station report-by times keyed by origin city → departure HH:MM */
export const STATION_REPORT_BY_DEPARTURE = {
  Nairobi: { '08:00': '07:25', '14:00': '13:25' },
  Arusha: { '08:00': '07:30', '14:00': '13:30' },
  Moshi: { '06:00': '05:30' },
};

export function normalizeTime(t) {
  return String(t || '').slice(0, 5);
}

export function isMainStation(city, hotelName) {
  const station = MAIN_STATION_BY_CITY[String(city || '')];
  if (!station || !hotelName) return false;
  return String(hotelName).trim() === station;
}

/** @returns {string|null} report-by time for main-station departures */
export function stationReportTime(originCity, departureTime) {
  const city = String(originCity || '');
  const dep = normalizeTime(departureTime);
  return STATION_REPORT_BY_DEPARTURE[city]?.[dep] ?? null;
}

/** @returns {string|null} HH:MM hotel pickup, or null for airport / main station */
export function hotelPickupTime(originCity, departureTime, { hasHotelPickup = true, pickupHotelName } = {}) {
  if (hasHotelPickup === false) return null;
  const city = String(originCity || '');
  if (city === 'JKIA' || city === 'Namanga') return null;
  if (pickupHotelName && isMainStation(city, pickupHotelName)) return null;
  const dep = normalizeTime(departureTime);
  return HOTEL_PICKUP_BY_CITY[city]?.[dep] ?? null;
}

export function formatDepartureSchedule(originCity, departureTime, options = {}) {
  const departure = normalizeTime(departureTime);
  const city = String(originCity || '');
  const pickupHotelName = options.pickupHotelName ?? null;
  const pickup = hotelPickupTime(originCity, departure, options);
  const atMainStation = pickupHotelName ? isMainStation(city, pickupHotelName) : false;
  const stationName = atMainStation ? MAIN_STATION_BY_CITY[city] : null;
  const reportByTime = atMainStation ? stationReportTime(city, departure) : null;

  let boardingLine = null;
  if (pickup) {
    boardingLine = `Be ready at your hotel by ${pickup} for ${departure} departure.`;
  } else if (atMainStation && reportByTime) {
    boardingLine = `Be at ${stationName} by ${reportByTime} for ${departure} departure.`;
  } else if (atMainStation && stationName) {
    boardingLine = `Be at ${stationName} for ${departure} departure.`;
  }

  return {
    departure,
    hotelPickup: pickup,
    departureLabel: `${departure} departure`,
    pickupHint: pickup ? `Hotel pickup from ${pickup}` : null,
    atMainStation,
    stationName,
    reportByTime,
    boardingLine,
  };
}
